const squash = (t) => t.replace(/\s+/g, " ").trim();

function locate(paras, h) {
  const parts = h.text.split(/\n+/).map(squash).filter((t) => t.length > 1);
  const out = [];
  parts.forEach((t, i) => {
    if (h.para != null) {
      const p = h.para + i;
      if (p >= paras.length) return;
      const hint = i === 0 ? h.start ?? 0 : 0;
      const at = paras[p].slice(hint, hint + t.length) === t ? hint : paras[p].indexOf(t);
      if (at >= 0) out.push({ p, start: at, end: at + t.length });
    } else {
      const p = paras.findIndex((para) => para.includes(t));
      if (p >= 0) out.push({ p, start: paras[p].indexOf(t), end: paras[p].indexOf(t) + t.length });
    }
  });
  return out;
}

function runs(para, owners) {
  const out = [];
  let i = 0;
  while (i < para.length) {
    let j = i;
    while (j < para.length && owners[j] === owners[i]) j++;
    out.push({ text: para.slice(i, j), id: owners[i] });
    i = j;
  }
  return out;
}

export default function HighlightedText({ text, highlights, onMarkClick }) {
  const paras = text.split("\n\n");
  const owners = paras.map((p) => new Array(p.length).fill(null));
  highlights.forEach((h) =>
    locate(paras, h).forEach(({ p, start, end }) => {
      for (let k = start; k < end; k++) owners[p][k] = h.id;
    })
  );
  return (
    <div className="reader-text fade-up" data-testid="reader-text">
      {paras.map((para, i) => (
        <p key={i} data-para={i} className={i === 0 && para.length > 180 ? "drop-cap" : undefined}>
          {runs(para, owners[i]).map((seg, j) =>
            seg.id ? (
              <mark
                key={j}
                className="reader-highlight"
                data-testid={`highlight-mark-${seg.id}`}
                onClick={(e) => onMarkClick(seg.id, e.currentTarget.getBoundingClientRect())}
              >
                {seg.text}
              </mark>
            ) : (
              <span key={j}>{seg.text}</span>
            )
          )}
        </p>
      ))}
    </div>
  );
}
